export const AWS_ACCOUNT_ID = 'awsAccountId';
